import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>Panel Principal</h1>
          <p style={styles.subtitle}>
            Bienvenido{user?.email ? `, ${user.email.split('@')[0]}` : ''}
          </p>
        </div>
      </div>

      {/* Hero */}
      <div style={styles.hero} className="card">
        <div style={styles.heroLeft}>
          <div style={styles.logoLarge}>VS</div>
          <div>
            <h2 style={styles.heroTitle}>VivaSmart</h2>
            <p style={styles.heroDesc}>
              Sistema integrado de planeación agrícola.<br />
              Gestiona cultivos, actividades y colaboradores en un solo lugar.
            </p>
            <button
              className="btn btn-primary"
              onClick={() => navigate('/planeacion')}
              style={{ marginTop: 16 }}
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="4" width="18" height="18" rx="2"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
              </svg>
              Ir a Planeación Diaria
            </button>
          </div>
        </div>
        <div style={styles.heroRight}>
          {/* decorative circles */}
          <div style={{ ...styles.circle, width: 180, height: 180, background: 'var(--accent-light)', top: -40, right: -40 }} />
          <div style={{ ...styles.circle, width: 100, height: 100, background: 'rgba(63,81,181,0.06)', bottom: 10, right: 100 }} />
        </div>
      </div>

      {/* Stats */}
      <div style={styles.statsGrid}>
        {[
          { label: 'Módulo activo', value: 'Planeación diaria', icon: '📅', color: 'var(--accent)' },
          { label: 'Unidades de negocio', value: 'Culiacán · Ensenada · San Carlos', icon: '🌿', color: 'var(--accent-green)' },
          { label: 'Estado del sistema', value: 'Operativo', icon: '✅', color: 'var(--accent-green)' },
        ].map((s, i) => (
          <div key={i} style={styles.statCard} className="card">
            <span style={{ fontSize: 24 }}>{s.icon}</span>
            <div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 600 }}>
                {s.label}
              </div>
              <div style={{ fontSize: 13, fontWeight: 600, color: s.color, marginTop: 3 }}>
                {s.value}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  page: { padding: '28px 32px', display: 'flex', flexDirection: 'column', gap: 24 },
  header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  title: { fontSize: 20, fontWeight: 700, color: 'var(--text-primary)' },
  subtitle: { fontSize: 13, color: 'var(--text-secondary)', marginTop: 2 },
  hero: {
    padding: '36px 40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    overflow: 'hidden',
    minHeight: 180,
  },
  heroLeft: { display: 'flex', alignItems: 'center', gap: 24, position: 'relative', zIndex: 1 },
  heroRight: { position: 'relative', width: 200, height: 120, flexShrink: 0 },
  logoLarge: {
    width: 64, height: 64,
    background: '#fdd835',
    borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 24, fontWeight: 800, color: '#1a237e',
    flexShrink: 0,
    boxShadow: '0 4px 16px rgba(253,216,53,0.4)',
  },
  heroTitle: { fontSize: 24, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 6, letterSpacing: '-0.02em' },
  heroDesc: { fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.7, maxWidth: 360 },
  circle: { position: 'absolute', borderRadius: '50%' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 14 },
  statCard: { padding: '16px 18px', display: 'flex', alignItems: 'center', gap: 14 },
};
